import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line max-len
import { AlternateServerResponse } from '@app/modules/system-settings/global-setup/alternate-host-server-setup/models/alternate-server-response.model';
import { ApiResponse, GlobalServerItem } from '../models';

@Injectable()
export class GlobalServerService {
	endpointBase = '/api/globalServer';

	constructor(private readonly http: HttpClient) {}

	getList() {
		return this.http.get<ApiResponse<'items', GlobalServerItem[]>>(this.endpointBase + '/list');
	}

	getItem(id) {
		return this.http.get<AlternateServerResponse>(this.endpointBase, { params: { id: id } });
	}

	addItem(item) {
		return this.http.put(this.endpointBase, item);
	}

	deleteItem(id) {
		return this.http.delete(this.endpointBase, { params: { Id: id } });
	}

	saveItem(item) {
		if (item.Id === 0) {
			return this.addItem(item);
		}
		return this.http.post(this.endpointBase, item);
	}

	testConnection(item) {
		return this.http.post(this.endpointBase + '/testConnection', item);
	}
}
